import { render, staticRenderFns } from "./ItemAdminKeyResult.vue?vue&type=template&id=540b5bc8&"
import script from "./ItemAdminKeyResult.vue?vue&type=script&lang=js&"
export * from "./ItemAdminKeyResult.vue?vue&type=script&lang=js&"
import style0 from "./ItemAdminKeyResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports